import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  PURCHASE_ORDER,
  PURCHASE_ORDERS,
} from '../graphql/query/purchase-order.query';
import { Apollo } from 'apollo-angular';
import {
  CANCEL_PO,
  CREATE_PURCHASE_ORDER,
  GENERATE_PO_PDF,
  MARK_AS_APPROVED,
  MARK_AS_ISSUED,
  UPDATE_PURCHASE_ORDER,
} from '../graphql/mutation/purchase-order.mutation';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderService {
  constructor(private apollo: Apollo) {}

  fetchAllPurchaseOrder(input: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: PURCHASE_ORDERS,
        variables: {
          input,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((response) => response.data.purchaseOrders));
  }
  fetchPurchaseOrder(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: PURCHASE_ORDER,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((response) => response.data.purchaseOrder));
  }

  createPurchaseOrder(createPurchaseOrderInput: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: CREATE_PURCHASE_ORDER,
        variables: {
          createPurchaseOrderInput,
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(map((result: any) => result.data.createPurchaseOrder || []));
  }

  updatePurchaseOrder(id: any, input: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: UPDATE_PURCHASE_ORDER,
        variables: {
          id,
          input,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.updatePurchaseOrder || []));
  }
  markPurchaseOrderAsApproved(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: MARK_AS_APPROVED,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.markPurchaseOrderAsApproved || []));
  }
  generatePoPdf(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: GENERATE_PO_PDF,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.generatePoPdf || []));
  }
  cancelPurchaseOrder(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: CANCEL_PO,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.cancelPurchaseOrder || []));
  }
  markAsIssued(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: MARK_AS_ISSUED,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.markAsIssued || []));
  }
}
